<ng-template #cardTemplate>
  @for (item of items | async; track item) {
    <eas-booking-type-slot [bookingType]="item"></eas-booking-type-slot>
  }
</ng-template>

<app-list title="Booking item types" i18n-title
  [cardTemplate]="cardTemplate"
  [actions]="actions"
></app-list>
